
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import Resources from './_resources.mdx';
import Cta from '@/partials/Cta'
const Layout = require('@/layouts/RootFileLayout').RootFileLayout;
const meta = {
  "title": "Building a Donation Marketplace Platform app like Thrift+",
  "date": "2019-10-03"
};
const slug = 'building-an-donation-marketplace-app-like-thrift';
const tableOfContents = [{
  "title": "Different type of Donation Marketplace Platform",
  "slug": "different-type-of-donation-marketplace-platform",
  "children": []
}, {
  "title": "Website Flow",
  "slug": "website-flow",
  "children": []
}, {
  "title": "Platform owner",
  "slug": "platform-owner",
  "children": []
}, {
  "title": "Donors userflow",
  "slug": "donors-userflow",
  "children": []
}, {
  "title": "Receiver userflow",
  "slug": "receiver-userflow",
  "children": []
}, {
  "title": "PREMIUM: Mobile APP",
  "slug": "premium-mobile-app",
  "children": []
}, {
  "title": "How to build/cost for donation marketplace app?",
  "slug": "how-to-build-cost-for-donation-marketplace-app",
  "children": []
}, {
  "title": "Resources to build, launch and grow marketplaces",
  "slug": "resources-to-build-launch-and-grow-marketplaces",
  "children": []
}];
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const TemplatesCards = makeShortcode("TemplatesCards");
const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = require('@/layouts/CustomContentsLayout').CustomContentsLayout
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <p>{`Building and launching a donation marketplace can be rewarding. Our previous experiences working with social enterprises tell us how we have brought happiness to people’s living and bringing change.`}</p>
    <p>{`As Tradly, We always believe in ethics, impact, and meaningful activities. Build a donation marketplace or an infrastructure for all our users to build something similar like `}<strong parentName="p">{`Thrift, GlobalGiving`}</strong>{`, etc is one of our main goals.`}</p>
    <p>{`You could be anything from a general donation marketplace or community-specific ones, Tradly Platform has the `}<a parentName="p" {...{
        "href": "https://tradly.app/features"
      }}>{`features`}</a>{`. `}<em parentName="p">{`Something is missing?`}</em>{` we can build for you.`}</p>
    <Cta mdxType="Cta" />
    <p><em parentName="p"><a parentName="em" {...{
          "href": "https://tradly.app/signup"
        }}>{`Signup to Start Building For Free ACCOUNT`}</a></em></p>
    <_Heading level={2} id={"different-type-of-donation-marketplace-platform"} nextElement={{
      "type": "paragraph"
    }}>Different type of Donation Marketplace Platform</_Heading>
    <p>{`There are different approaches in donation marketplaces. Each needs different features and technical adjustments in the infrastructure. Few use cases are`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul"><strong parentName="li">{`General peer to peer based donation marketplace platform:`}</strong>{` People can post their give away items and allow anybody to avail those items.`}</li>
      <li parentName="ul"><strong parentName="li">{`Specific union private based marketplace`}</strong>{` platform: Same like general donation marketplace but users will be able to access the apps only through invite links. This style of private marketplaces can be created for bigger corporations, Union, groups and organisations which has thousand of members under their group.`}</li>
      <li parentName="ul"><strong parentName="li">{`Multiple private groups based donation marketplace platform:`}</strong>{` This are special marketplace platform where you don’t have an open marketplace but multiple groups will be created in the platform. Each people can be joined only through an invite from group owners.`}</li>
      <li parentName="ul"><strong parentName="li">{`People to Organisations relationship based platform:`}</strong>{` This is like Thrift+ where users can sell their item and give the sales to their favourite charities.`}</li>
      <li parentName="ul">{`And many others`}</li>
    </ul>
    <p>{`Having `}<a parentName="p" {...{
        "href": "https://tradly.app"
      }}>{`smart apps`}</a>{` help your users stay connected, easy, and always on reach. Whatever the flexibility you want to have, Tradly platform allows you to have interactions between the donor and the other side.  All these interactions in their smartphone with easy-to-use and personalized features for both parties. Let’s show quickly what both the parties will get and how it works`}</p>
    <_Heading level={2} id={"website-flow"} nextElement={{
      "type": "heading",
      "depth": 2
    }}>Website Flow</_Heading>
    <_Heading level={2} id={"platform-owner"} nextElement={{
      "type": "list",
      "ordered": true,
      "start": 1,
      "spread": false
    }}>Platform owner</_Heading>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`Self Signup, an account with Tradly`}</li>
      <li parentName="ol">{`When you register, you will be automatically assigned a Marketplace template (but you can change them later) `}</li>
      <li parentName="ol">{`Go to SuperAdmin, the place where you can configure`}
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`how to onboard your account, `}</li>
          <li parentName="ul">{`how to collect donation listing (like what information you need from, category, etc) `}</li>
          <li parentName="ul">{`product shipping preferences`}</li>
          <li parentName="ul">{`Add some promotional banners on the homepage, etc.`}</li>
        </ul>
      </li>
    </ol>
    <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/platform-owner.png" />
      </div>
    <_Heading level={2} id={"donors-userflow"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Donors userflow</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Open a donor account: they can select whether they want shipment preferences like pickup collection, drop off. Or you can even configure collection points where people can drop off / pickup. `}</li>
      <li parentName="ul">{`Post the items as listing which are available as donations (Item picture, description, condition, category, Age, Size, Gender) `}</li>
      <li parentName="ul">{`The item is live in the marketplace.`}
        <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/donor-steps.png" />
      </div>
      </li>
    </ul>
    <_Heading level={2} id={"receiver-userflow"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Receiver userflow</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Register an account`}</li>
      <li parentName="ul">{`Browse the products posted `}</li>
      <li parentName="ul">{`If any product is needed by them, they can claim it. `}</li>
      <li parentName="ul">{`On the checkout page, based on donor preference, they can choose the available PICKUP or DELIVERY. If the donor has included a shipping fee, then it will be charged. `}</li>
      <li parentName="ul">{`When the receiver orders this, the donor will receive the notification via email. `}</li>
      <li parentName="ul">{`The receiver can go to a pickup place or receive via delivery. `}</li>
    </ul>
    <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/receiver-steps.png" />
      </div>
    <TemplatesCards category_id={3865} title={'Marketplace Templates'} isShowBtn={true} mdxType="TemplatesCards" /> 
    <_Heading level={2} id={"premium-mobile-app"} nextElement={{
      "type": "jsx"
    }}>PREMIUM: Mobile APP</_Heading>
    <img class="w-92 h-82 object-cover rounded-lg shadow-lg" src={require('../img/tradly/Onboarding_2-473x1024.png').default} alt="Onboarding" width="300" />
    <p>{`Intuitive screens`}</p>
    <img class="w-92 h-82 object-cover rounded-lg shadow-lg" src={require('../img/tradly/Create-Group-398x1024.png').default} alt="Onboarding_2-473x1024" width="300" />
    <p>{`Create different type of community groups`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Donor take the picture and upload the item`}</li>
      <li parentName="ul">{`They can select the preferred NGO they want to donate`}</li>
      <li parentName="ul">{`Both of them can communicate with the organisation via inbuilt chat`}</li>
    </ul>
    <p>{`+`}{` Other 25 features you can check in our documentations`}</p>
    <img class="w-92 h-82 object-cover rounded-lg shadow-lg" src={require('../img/tradly/Social-Feeds-1.png').default} alt="Social-Feeds-1" width="300" />
    <img class="w-92 h-82 object-cover rounded-lg shadow-lg" src={require('../img/tradly/Search-List-1.png').default} alt="Search-List-1" width="300" />
    <img class="w-92 h-82 object-cover rounded-lg shadow-lg" src={require('../img/tradly/OTP-Verfication_SMS.png').default} alt="OTP-Verfication_SMS" width="300" />
    <img class="w-92 h-82 object-cover rounded-lg shadow-lg" src={require('../img/tradly/Onboarding_personalisation.png').default} alt="Onboarding_personalisation" width="300" />
    <img class="w-92 h-82 object-cover rounded-lg shadow-lg" src={require('../img/tradly/Notifications_detailed.png').default} alt="Notifications_detailed" width="300" />
    <img class="w-92 h-82 object-cover rounded-lg shadow-lg" src={require('../img/tradly/HomeScreen_CategoryBased.png').default} alt="HomeScreen_CategoryBased" width="300" />
    <img class="w-92 h-82 object-cover rounded-lg shadow-lg" src={require('../img/tradly/Chat-Messages-2.png').default} alt="Chat-Messages-2" width="300" />
    <_Heading level={2} id={"how-to-build-cost-for-donation-marketplace-app"} nextElement={{
      "type": "paragraph"
    }}>How to build/cost for donation marketplace app?</_Heading>
    <p>{`It’s simple with Tradly platform. Start your app with $ZERO and pay as you go based on the growth. Moreover, it’s a white-labeled solution!`}</p>
    <p>{`Let’s not stop there. Imagine in few weeks or in a year, your platform becomes a huge success and you want to optimize the app screens or you want to totally change the backend system to accommodate new things, you can upgrade your plan and do the transition easily with our infrastructure.`}</p>
    <p>{`Donation marketplaces are also called `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Crowdfunding"
      }}>{`crowdfunding`}</a>{`. Crowdfunding is a form of `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Crowdsourcing"
      }}>{`crowdsourcing`}</a>{` and `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Alternative_Finance"
      }}>{`alternative finance`}</a></p>
    <Cta mdxType="Cta" />
    <_Heading level={2} id={"resources-to-build-launch-and-grow-marketplaces"} nextElement={{
      "type": "jsx"
    }}>Resources to build, launch and grow marketplaces</_Heading>
    <Resources mdxType="Resources" />



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
